import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { ReportPage } from '@/components/reports/report-page'
import { ExpenseReport } from '@/components/reports/expenses/expense-report'
import { validateExpenseReportSearch } from '@/components/reports/expenses/expense-report-search'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/expenses')(
    {
        validateSearch: (raw: Record<string, unknown>) =>
            validateExpenseReportSearch(raw),
        component: ExpenseReportPage,
    },
)

function ExpenseReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={m.expense_report_page_title()}>
            <ExpenseReport
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
